import { ChevronRightIcon } from '@heroicons/react/20/solid';

import clsx from 'clsx';
import React from 'react';

export default function BreadCrumb({ className, items }) {
  return (
    <div className={clsx('flex items-center flex-wrap', className)}>
      {items.map((item, index) =>
        item.current ? (
          <div key={index} className="flex items-center">
            <span href={item.url} className="text-content-subdued text-sm">
              {item.label}
            </span>
          </div>
        ) : (
          <div key={index} className="flex items-center">
            <a href={item.url} className="text-content-secondary text-sm">
              {item.label}
            </a>
            <ChevronRightIcon className="w-5 h-5 text-content-secondary mx-1" />
          </div>
        ),
      )}
    </div>
  );
}
